const BattleCalc = require('./BattleCalc');
const ResistEvent = require('./events/ResistEvent');

const CCHandler = {
  checkForResistMental: function (victim, battleState) {
    var hasOption = BattleCalc.getCondition(victim, 'has_option');
    if (hasOption) {
      new ResistEvent(battleState, victim).execute();
      battleState.expireCondition(hasOption.uid);
      return true;
    }

    if (Math.random() * 100 <= victim.attributes.mentalResil) {
      new ResistEvent(battleState, victim).execute();
      return true;
    }

    return false;
  },

  checkForResistRage: function (victim, battleState) {
    if (BattleCalc.getCondition(victim, 'enraged')) {
      new ResistEvent(battleState, victim).execute();
      return true;
    } else {
      return CCHandler.checkForResistMental(victim, battleState);
    }
  },

  checkForResistFear: function (victim, battleState) {
    if (BattleCalc.getCondition(victim, 'scared')) {
      new ResistEvent(battleState, victim).execute();
      return true;
    } else {
      return CCHandler.checkForResistMental(victim, battleState);
    }
  },

  checkForResistPhysical: function (victim, battleState) {
    var hasOption = BattleCalc.getCondition(victim, 'has_option');
    if (hasOption) {
      new ResistEvent(battleState, victim).execute();
      battleState.expireCondition(hasOption.uid);
      return true;
    }

    if (Math.random() * 100 <= victim.attributes.physicalResil) {
      new ResistEvent(battleState, victim).execute();
      return true;
    }

    return false;
  },

  checkForResistSlow: function (victim, battleState) {
    if (BattleCalc.getCondition(victim, 'slowed')) {
      new ResistEvent(battleState, victim).execute();
      return true;
    } else {
      return CCHandler.checkForResistPhysical(victim, battleState);
    }
  },

  checkForResistStun: function (victim, battleState) {
    if (BattleCalc.getCondition(victim, 'stunned')) {
      new ResistEvent(battleState, victim).execute();
      return true;
    } else {
      return CCHandler.checkForResistPhysical(victim, battleState);
    }
  },
};
module.exports = CCHandler;
